<template>
  <VImg :src="blobUrl" v-bind="$attrs">
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}"></slot>
    </template>
  </VImg>
</template>

<script>
import usePOG from './pog/usePOG';
import { onBeforeUnmount, ref, watch } from '@vue/composition-api';
import useSkutopia from './useSkutopia';


export default {
    props:{
      src: { type: String, required: false, default: '' }
    },
    setup(props) {

        const blobUrl = ref('');
        const { fetchSecureMediaBlob } = useSkutopia();

        watch(() => props.src, async (newUrl) => {
          // Clean up old memory
          if (blobUrl.value) {
            URL.revokeObjectURL(blobUrl.value);
            blobUrl.value = '';
          }
          
          if (newUrl) {
            // Securely fetch and convert to local blob
            blobUrl.value = await fetchSecureMediaBlob(newUrl);
          }
        }, { immediate: true });

        onBeforeUnmount(() => {
          if (blobUrl.value) {
            URL.revokeObjectURL(blobUrl.value);
          }
        });

        return {
          blobUrl
        }
    }
  }
</script>
